/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  Security,
  UniverseSecurityItemsParams
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * List securities. Backwards-compatible: no params → full list.
 * @summary Universe Security Items
 */
export const universeSecurityItems = (
    params?: UniverseSecurityItemsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<Security[]>(
      {url: `/securities/universes/security-items`, method: 'GET',
        params, signal
    },
      options);
    }




export const getUniverseSecurityItemsQueryKey = (params?: UniverseSecurityItemsParams,) => {
    return [
    `/securities/universes/security-items`, ...(params ? [params] : [])
    ] as const;
    }


export const getUniverseSecurityItemsQueryOptions = <TData = Awaited<ReturnType<typeof universeSecurityItems>>, TError = HTTPValidationError>(params?: UniverseSecurityItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof universeSecurityItems>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUniverseSecurityItemsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof universeSecurityItems>>> = ({ signal }) => universeSecurityItems(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof universeSecurityItems>>, TError, TData> & { queryKey: QueryKey }
}

export type UniverseSecurityItemsQueryResult = NonNullable<Awaited<ReturnType<typeof universeSecurityItems>>>
export type UniverseSecurityItemsQueryError = HTTPValidationError


/**
 * @summary Universe Security Items
 */

export function useUniverseSecurityItems<TData = Awaited<ReturnType<typeof universeSecurityItems>>, TError = HTTPValidationError>(
 params?: UniverseSecurityItemsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof universeSecurityItems>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUniverseSecurityItemsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






